import { Button, Theme, useMediaQuery, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { usePopover } from 'src/hooks/use-popover';
import { useViewContextName } from 'src/hooks/use-view-context-name';
import { Briefcase as BriefcaseIcon } from 'src/icons/briefcase';
import { ChevronDown } from 'src/icons/chevron-down';
import { createOutsideClickHandler } from 'src/utils/create-outside-click-handler';
import { AvailableIssueManagerContextsPopper } from '../molecules/available-issue-manager-contexts-popper';

export const IssueManagerContextSelector = () => {
  const getViewContextName = useViewContextName();

  const {
    palette: { mode },
  } = useTheme();

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const [
    issueManagerAnchorRef,
    openIssueManagerMenu,
    handleOpenIssueManagerMenu,
    handleCloseIssueManagerMenu,
  ] = usePopover();

  useEffect(() => {
    createOutsideClickHandler(
      [issueManagerAnchorRef],
      handleCloseIssueManagerMenu,
    );
  }, []);

  return (
    <>
      <Button
        color="primary"
        onClick={
          openIssueManagerMenu
            ? handleCloseIssueManagerMenu
            : handleOpenIssueManagerMenu
        }
        ref={issueManagerAnchorRef}
        size={isMobile ? 'medium' : 'large'}
        variant="text"
        startIcon={
          <BriefcaseIcon
            fontSize="small"
            sx={{
              color: mode === 'dark' ? '#fff' : '#000',
              width: '16px',
            }}
          />
        }
        endIcon={<ChevronDown fontSize="small" />}
        sx={{
          ml: 1,
          mr: 2,
          alignItems: 'center',
          fontWeight: 400,
          color: 'text.primary',
          '&:hover': {
            color: 'text.primary',
          },
          '&:active': {
            color: 'text.primary',
          },
          '&:focus': {
            color: 'text.primary',
          },
        }}>
        {getViewContextName()}
      </Button>

      <AvailableIssueManagerContextsPopper
        anchorRef={issueManagerAnchorRef}
        open={openIssueManagerMenu}
        onClose={handleCloseIssueManagerMenu}
        placement="bottom-end"
      />
    </>
  );
};
